
export default {
    name: "HappyKidsSubcategory",
    props: {
        data: {
            type: Object,
            default: () => ({})
        },
        disclaimer: {
            type: String,
            default: '',
        }
    },
    computed: {
        displayProducts() {
            const product = this.$route.query.category ? this.data?.CoverageType.find(coverage => coverage?.Slug == this.$route.query.category) : this.data?.CoverageType.find(coverage => coverage?.Slug == this.$route.params.pathMatch)

            // const sortedProduct = this.sortProductsByOrderNum(product.Products)

            // if (sortedProduct.length > 0) {
            //     return sortedProduct;
            // }

            return product.Products;
        },
        displaySubcategories() {
            const currentSlug = this.$route.query.category ? this.$route.query.category : this.$route.params.pathMatch || this.$route.params.productSubcat;
            return this.data?.CoverageType.map(item => ({
                icon: item?.IconType,
                isActive: item?.Slug === currentSlug,
                target: '_self',
                text: item?.Name,
                slug: item?.Slug

            }))
        },
        displayTitle() {
            return this.data?.Title;
        },
        displayDescription() {
            return this.data?.Description
        },
        overrideStyle() {
            if (this.displayProducts.length == 3) {
                return {
                        gridTemplateColumns: 'repeat(3, minmax(270px, 340px))'
                    };
            }
            if (this.displayProducts.length == 2) {
                return {
                        gridTemplateColumns: 'repeat(2, minmax(270px, 340px))'
                    };
            }
            if (this.displayProducts.length == 1) {
                return {
                        gridTemplateColumns: 'repeat(1, minmax(270px, 340px))'
                    };
            }
            return null;
        }
    },
    methods: {
        // sortProductsByOrderNum(products) {
        //     try {
        //         const d = products.sort(() => Math.random() - 0.5)
        //         return d;
        //     } catch (error) {
        //         console.error('*** sortProductsByOrderNum error ***')
        //         if (!products) {
        //             console.error('products is null')
        //         }
        //         return null
        //     }
        // },
    },
}
